<footer class="footer" role="contentinfo">
    <div class="container footer-container">
        <button class="pts-Footer-toTop p-2 text-white text-nowrap" (click)="goToTop()" title="Retour haut de page"
                aria-labelledby="gotop">
            <img src="/content/images/pictos/arrow-top.svg" alt=""
                 class="me-2 align-baseline pts-Footer-toTop-icon" width="16">
            <span id="gotop" translate="footer.top"></span>
        </button>
        <div class="row footer-row">
            <div class="col-12 col-xl-2">
                <logo-marianne [isFooter]="true">Ministère<br>de la Justice</logo-marianne>
            </div>
            <div class="col-12 col-xl-10">
                <div class="d-flex justify-content-between">
                    <p class="custom footerTitle mb-3">penitentiaire.justice.fr</p>
                </div>
                <div class="row">
                    <span class="sr-only col-auto" id="footerLabel" translate="footer.label"></span>

                    <div class="navbar navbar-expand-md justify-content-start mainFooterNavbar pl-0"
                         aria-labelledby="footerLabel">
                        <ul class="navbar-nav text-nowrap">
                            <li class="nav-item">
                                <a (click)="goToTop()" routerLink="/contact" class="nav-link">
                                    <span translate="footer.contact"></span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a (click)="goToTop()" routerLink="/plan-du-site" class="nav-link">
                                    <span translate="footer.plan-site"></span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a (click)="goToTop()" routerLink="/mentions-legales" class="nav-link">
                                    <span translate="footer.mentions"></span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a (click)="goToTop()" routerLink="/accessibilite" class="nav-link">
                                    <span translate="footer.accessibilite.titre"></span>
                                    <span translate="footer.accessibilite.conformite"></span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="navbar navbar-expand-md justify-content-center secondaryFooterNavbar"
         aria-labelledby="footerLabel">
        <div class="container d-block">
            <div class="row justify-content-md-center">
                <ul class="navbar-nav justify-content-center">
                    <li class="nav-item">
                        <a class="nav-link" href="https://www.gouvernement.fr/" rel="noopener noreferrer"
                           target="_blank">
                            Gouvernement.fr
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="https://www.legifrance.gouv.fr/"
                           rel="noopener noreferrer"
                           target="_blank">
                            Legifrance.gouv.fr
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="https://www.justice.fr/" rel="noopener noreferrer"
                           target="_blank">
                            Justice.fr
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="https://www.service-public.fr/" rel="noopener noreferrer"
                           target="_blank">
                            Service-public.fr
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="https://www.france.fr/fr" rel="noopener noreferrer"
                           target="_blank">
                            France.fr
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="https://www.data.gouv.fr/fr/" rel="noopener noreferrer"
                           target="_blank">
                            Data.gouv.fr
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="container-fluid">
        <p class="legals">© Ministère de la Justice - {{mois + ' ' + annee}} - Penitentiaire.justice.fr, le site
            officiel à destination des proches des détenus.</p>
        <div class="text-center">
            <span class="legals">{{version.toLowerCase()}}</span>
        </div>
    </div>

</footer>
